<router-outlet><app-spinner><app-title></app-title></app-spinner></router-outlet>
<ngx-toasta [position]="'top-right'"></ngx-toasta>
